module.exports = __webpack_public_path__ + "school/img/gaodengJc.8e545e78.jpg";